<template>
  <div
    class="
      w-8
      h-8
      rounded-full
      bg-white-005
      flex
      items-center
      justify-center
      cursor-pointer
      hover:bg-white-030
      transition-all
    "
    @click="share"
  >
    <i class="iconfont icon-fenxiang2 text-xs"></i>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  tip: String,
});

const share = () => {
  const twTittle = `${props.tip} By @thepass_to `;
  const twUrl = `${window.location.origin}`;
  window.open(
    `https://twitter.com/intent/tweet?text=${twTittle}&url=${twUrl}`,
    '_blank',
  );
};
</script>

<style lang="scss" scoped></style>
